import { getKYCStatusDetails, KYC_LABELS, KYC_UPDATE_DATE } from 'helpers/kycStatus';
import type { KYCVerificationInterface } from 'helpers/kycStatus';
import { userSelector } from 'selectors/otherSelectors';
import { useAppSelector } from 'storeHooks';

const useKYC = (): KYCVerificationInterface => {
  const user = useAppSelector(userSelector);
  return getKYCStatusDetails(user);
};

export type { KYCVerificationInterface };
export { KYC_LABELS, KYC_UPDATE_DATE };
export default useKYC;
